// extracted by mini-css-extract-plugin
module.exports = {"wizardFooter":"footer_wizardFooter__1xMXN","footerItem":"footer_footerItem__2JeWe"};